class EventBus {
  constructor() {
    this.eventMap = new Map();
  }

  publish(eventName, ...args) {
    const callbacks = this.eventMap.get(eventName);
    if (!callbacks) return console.warn(`${eventName} not found!`);
    callbacks.forEach((callback) => callback(...args));
  }

  subscribe(eventName, callback) {
    let callbacks = this.eventMap.get(eventName);
    if (!callbacks) {
      callbacks = [];
      this.eventMap.set(eventName, callbacks);
    }
    callbacks.push(callback);

    return {
      unsubscribe: () => {
        this.eventMap.set(eventName, callbacks.filter((cb) => cb !== callback));
      },
    };
  }

  subscribeOnce(eventName, callback) {
    const unsubscribe = this.subscribe(eventName, (...args) => {
      callback(...args);
      unsubscribe();
    });
    return { unsubscribe };
  }

  clear(eventName) {
    if (!eventName) {
      this.eventMap.clear();
      return;
    }
    this.eventMap.delete(eventName);
  }
}

export { EventBus };